// extracted by mini-css-extract-plugin
module.exports = {"block":"CreateTeamModal_block__25MSc","autoComplete":"CreateTeamModal_autoComplete__VX788","avatar":"CreateTeamModal_avatar__9Efpp"};